import { FilloutStandardEmbed } from '@fillout/react';

const FILLOUT_FORM_ID = '7Ju7ZvN5fzus';

export default function StudentCTA() {
  return (
    <section id="join-community" className="bg-background py-20 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="font-playfair text-3xl md:text-5xl font-medium italic text-foreground text-center mb-4">
          Join the Interview Prep Community
        </h2>
        <p className="text-center text-muted-foreground mb-10 max-w-xl mx-auto">
          Get added to our interview prep group. We'll share tips, practice sessions, and new features as they launch.
        </p>

        <div className="rounded-2xl overflow-hidden border border-border shadow-lg">
          <FilloutStandardEmbed filloutId={FILLOUT_FORM_ID} dynamicResize />
        </div>
      </div>
    </section>
  );
}
